/**
 * Íconos SVG en línea, dibujados con `currentColor`: toman el color del texto y se adaptan
 * solos al tema y a la marca. Trazo uniforme para que se lean como familia.
 *
 * Están acá y no en archivos sueltos porque son parte del vocabulario: el ícono de "pagado"
 * tiene que ser el mismo en el badge, en el veredicto y en el comprobante.
 */
const TRAZOS: Record<string, string> = {
  // Navegación
  mostrador: 'M3 10h18M5 10V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4M4 10v9h16v-9M9 14h6',
  tablero: 'M4 13h6V4H4zM14 20h6v-9h-6zM14 4v4h6V4zM4 20h6v-4H4z',
  integrantes: 'M16 19v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 17.5V19M10 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM20 19v-1.5a3.5 3.5 0 0 0-2.5-3.35M15.5 4.6a3 3 0 0 1 0 5.8',
  actividades: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4M8 14h3M8 17h6',
  dinero: 'M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 2.5 4.5 3 4.5 1.3 4.5 3-2 3-4.5 3-4.5-1.3-4.5-3',
  // El menú viene del contrato y usa estos nombres: son el mismo dibujo con el nombre del módulo.
  pagos: 'M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 2.5 4.5 3 4.5 1.3 4.5 3-2 3-4.5 3-4.5-1.3-4.5-3',
  padron: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4',
  reportes: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  equipo: 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z',
  catalogos: 'M4 6h16M4 12h16M4 18h10M4 6v.01M4 12v.01M4 18v.01',
  auditoria: 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6zM9 12l2 2 4-4',
  escudo: 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z',
  plataforma: 'M4 5h16v10H4zM8 19h8M12 15v4',
  configuracion:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 13.5l1.6 1-2 3.4-1.8-.6a7 7 0 0 1-2.2 1.3L14.6 21h-4l-.4-2.4a7 7 0 0 1-2.2-1.3l-1.8.6-2-3.4 1.6-1a7 7 0 0 1 0-3L4.2 9.5l2-3.4 1.8.6a7 7 0 0 1 2.2-1.3L10.6 3h4l.4 2.4a7 7 0 0 1 2.2 1.3l1.8-.6 2 3.4-1.6 1a7 7 0 0 1 0 3z',

  // Semáforo y estados
  check: 'M5 12.5l4.5 4.5L19 7.5',
  alto: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12h8',
  alerta: 'M12 4l9 16H3zM12 10v4M12 17.5v.01',
  anular: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM5.7 5.7l12.6 12.6',
  candado: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  reloj: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  calendario: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',

  // Acciones
  mas: 'M12 5v14M5 12h14',
  buscar: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4',
  cerrar: 'M6 6l12 12M18 6L6 18',
  editar: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
  imprimir: 'M7 9V3h10v6M7 17H4v-7h16v7h-3M7 14h10v7H7z',
  importar: 'M12 3v11M8 10l4 4 4-4M4 19h16',
  descargar: 'M4 16v3h16v-3M12 4v11M8 11l4 4 4-4',
  cambiar: 'M4 8h13l-3-3M20 16H7l3 3',
  salir: 'M15 4h4v16h-4M10 16l4-4-4-4M14 12H4',
  filtro: 'M4 5h16l-6 7v6l-4 2v-8z',
  ojo: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  menu: 'M4 7h16M4 12h16M4 17h16',
  teclado: 'M3 7h18v10H3zM7 11h.01M11 11h.01M15 11h.01M8 14h8',

  // Flechas
  derecha: 'M9 6l6 6-6 6',
  izquierda: 'M15 6l-6 6 6 6',
  abajo: 'M6 9l6 6 6-6',
  arriba: 'M6 15l6-6 6 6',

  // Personas y datos
  usuario: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0',
  cedula: 'M3 6h18v12H3zM7 10h.01M11 10h6M11 14h4M6 15a2.5 2.5 0 0 1 3 0',
  comprobante: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3',
  zona: 'M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  telefono: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z',
  tendencia: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  estrella: 'M12 4l2.4 5 5.6.8-4 3.9.9 5.5-4.9-2.6-4.9 2.6.9-5.5-4-3.9 5.6-.8z',
  hoja: 'M8 4h8a2 2 0 0 1 2 2v14l-6-3-6 3V6a2 2 0 0 1 2-2z',

  // Tema y conexión
  sol: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  luna: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  monitor: 'M3 5h18v11H3zM8 20h8M12 16v4',
  desconectado: 'M3 3l18 18M8.5 16.5a5 5 0 0 1 7 0M5 13a10 10 0 0 1 4-2.4M19 13a10 10 0 0 0-6-2.9M12 20h.01',
};

export type NombreIcono = keyof typeof TRAZOS | string;

export function Icono({ nombre, clase, titulo }: { nombre: NombreIcono; clase?: string; titulo?: string }) {
  const trazo = TRAZOS[nombre] ?? TRAZOS.hoja!;
  return (
    <svg
      className={`icono ${clase ?? ''}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={titulo ? undefined : true}
      role={titulo ? 'img' : undefined}
    >
      {titulo ? <title>{titulo}</title> : null}
      <path d={trazo} />
    </svg>
  );
}
